import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import { MerchantContractContainerModel } from "../../../../../models/aggregates/pgw/merchant-contract.model";
import { MerchantContractCriteriaModelQuery, MerchantContractQueryCriteriaClass } from "../../criteria/pgw/merchant-contract-criteria.model";

@Injectable({
  providedIn: "root",
})
export class MerchantContractService extends BaseApiTemplateService<MerchantContractContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant-contract-hdr";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant-contract-hdr";
    this.httpClient = http;
  }

  getMercahntContractByCriteria(
    visa: ApiVisa,
    criteria?: MerchantContractQueryCriteriaClass
  ): Observable<PagingResponseModel<MerchantContractContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildMerchantContractCriteria = new MerchantContractCriteriaModelQuery(criteria);
    console.log("query", buildMerchantContractCriteria.query);
    return this.httpClient.get<PagingResponseModel<MerchantContractContainerModel>>(
      this.apiUrl + "/query?" + buildMerchantContractCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
